import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../services/api';
import Constants from '../../services/constants';

// Async thunks for API calls
export const setAuthToken = createAsyncThunk(
  'edgeAuth/setToken',
  async ({ org_id, auth_token }, { rejectWithValue }) => {
    try {
      const res = await api('post', Constants.END_POINT.edge_auth, {
        org_id,
        auth_token
      });
      if (res.success) {
        return res.data;
      }
      return rejectWithValue(res.message);
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);

export const getAuthToken = createAsyncThunk(
  'edgeAuth/getToken',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api('get', Constants.END_POINT.edge_auth);
      if (res.success) {
        return res.data;
      }
      return rejectWithValue(res.message);
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);

export const deleteAuthToken = createAsyncThunk(
  'edgeAuth/deleteToken',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api('delete', Constants.END_POINT.edge_auth);
      if (res.success) {
        return res.data;
      }
      return rejectWithValue(res.message);
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);

const initialState = {
  auth_token: null,
  loading: false,
  error: null
};

const edgeAuthSlice = createSlice({
  name: 'edgeAuth',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    // Set auth token
    builder
      .addCase(setAuthToken.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(setAuthToken.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(setAuthToken.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    // Get auth token
    builder
      .addCase(getAuthToken.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAuthToken.fulfilled, (state, action) => {
        state.loading = false;
        state.auth_token = action.payload.auth_token;
      })
      .addCase(getAuthToken.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    // Delete auth token
    builder
      .addCase(deleteAuthToken.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAuthToken.fulfilled, (state) => {
        state.loading = false;
        state.auth_token = null;
      })
      .addCase(deleteAuthToken.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearError } = edgeAuthSlice.actions;

export default edgeAuthSlice.reducer;
